import { SPECIAL_CURRENCY_ID } from '@/types/shared/player'
import FeatherImage from '@/assets/images/special-currencies/feather.webp'
import GoldenEggImage from '@/assets/images/special-currencies/golden-egg.webp'
import CrownImage from '@/assets/images/special-currencies/crown.png'
import GemImage from '@/assets/images/special-currencies/gem.webp'
import KeyImage from '@/assets/images/special-currencies/key.webp'
import ParachuteImage from '@/assets/images/special-currencies/parachute.webp'
import PlantImage from '@/assets/images/special-currencies/plant.webp'
import TopHatImage from '@/assets/images/special-currencies/top-hat.webp'
import PuzzlePieceImage from '@/assets/images/special-currencies/puzzle-piece.webp'
import IdeaImage from '@/assets/images/special-currencies/idea.webp'
import { computed } from 'vue'
import { liveOpsCurrencies } from '@/composables/game/live-ops-events'

export type SpecialCurrencyConfig = { label: string; image: string }

export const specialCurrenciesConfig: Record<SPECIAL_CURRENCY_ID, SpecialCurrencyConfig> = {
  [SPECIAL_CURRENCY_ID.GOLD_FEATHER]: {
    label: 'Feathers',
    image: FeatherImage,
  },
  [SPECIAL_CURRENCY_ID.KEY]: {
    label: 'Keys',
    image: KeyImage,
  },
  [SPECIAL_CURRENCY_ID.GEM]: {
    label: 'Gems',
    image: GemImage,
  },
  [SPECIAL_CURRENCY_ID.GOLDEN_EGG]: {
    label: 'Eggs',
    image: GoldenEggImage,
  },
  [SPECIAL_CURRENCY_ID.CROWN]: {
    label: 'Crowns',
    image: CrownImage,
  },
  [SPECIAL_CURRENCY_ID.PARACHUTE]: {
    label: 'Parachutes',
    image: ParachuteImage,
  },
  [SPECIAL_CURRENCY_ID.PLANT]: {
    label: 'Plants',
    image: PlantImage,
  },
  [SPECIAL_CURRENCY_ID.TOP_HAT]: {
    label: 'Top Hats',
    image: TopHatImage,
  },
  [SPECIAL_CURRENCY_ID.PUZZLE_PIECE]: {
    label: 'Puzzle Pieces',
    image: PuzzlePieceImage,
  },
  [SPECIAL_CURRENCY_ID.IDEA]: {
    label: 'Ideas',
    image: IdeaImage,
  },
}

export const additionalLiveOpsCurrencies = computed(() =>
  liveOpsCurrencies.value.filter(c => !(c.id in specialCurrenciesConfig)),
)

export const allSpecialCurrenciesConfig = computed<Record<string, SpecialCurrencyConfig>>(() => {
  const merged: Record<string, SpecialCurrencyConfig> = { ...specialCurrenciesConfig }

  for (const currency of additionalLiveOpsCurrencies.value) {
    merged[currency.id] = {
      label: currency.name,
      image: currency.mediaUrl,
    }
  }

  return merged
})

